import { createFileRoute } from "@tanstack/react-router";
import { Download } from "lucide-react";

import { SectionHeading } from "../components/SectionHeading";
import { CtaBand } from "../components/CtaBand";
import { voorwaardenArtikelen, voorwaardenDocUrl } from "../lib/voorwaarden";
import { SITE_URL, ogImageDefault, ogImageMeta } from "../lib/seo";

const title = "Algemene leveringsvoorwaarden | Fedor Timmerwerken";
const description =
  "De algemene leveringsvoorwaarden van Fedor Timmerwerken uit Dordrecht: offertes, betaling, uitvoering en aansprakelijkheid.";

export const Route = createFileRoute("/voorwaarden")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: `${SITE_URL}/voorwaarden` },
      ...ogImageMeta(ogImageDefault, "Fedor Timmerwerken uit Dordrecht"),
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/voorwaarden` }],
  }),
  component: VoorwaardenPage,
});

function VoorwaardenPage() {
  return (
    <>
      <div className="py-14 sm:py-20 lg:py-28">
        <div className="container-tight">
          <SectionHeading
            as="h1"
            eyebrow="Voorwaarden"
            title="Algemene leveringsvoorwaarden"
            description="Deze voorwaarden gelden bij alle aanbiedingen en overeenkomsten waarbij Fedor Timmerwerken partij is."
            align="center"
            className="mx-auto"
          />

          <div className="mt-8 text-center">
            <a
              href={voorwaardenDocUrl}
              download
              className="inline-flex items-center justify-center gap-2 rounded-md border border-input bg-background px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
            >
              <Download className="h-4 w-4" aria-hidden="true" />
              Download als document
            </a>
          </div>

          <div className="mx-auto mt-10 sm:mt-14 max-w-3xl space-y-10">
            {voorwaardenArtikelen.map((artikel) => (
              <section key={artikel.nummer}>
                <h2 className="font-heading text-xl font-bold tracking-tight text-foreground">
                  Artikel {artikel.nummer} — {artikel.title}
                </h2>
                <div className="mt-3 space-y-3">
                  {artikel.paragraphs.map((p, i) => (
                    <p key={i} className="text-sm leading-relaxed text-muted-foreground">
                      {p}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>

      <CtaBand />
    </>
  );
}
